/* eslint-disable @typescript-eslint/no-explicit-any */
interface FieldErrorProps {
  field: string;
  form: any;
  className?: string;
}

export const ShowFormError = ({field, form, className}: FieldErrorProps) => {
  return form?.touched?.[field] && form?.errors?.[field] ? (
    <span className={`text-red-550 text-[0.7em] mt-[10px] block ${className}`}>
      {String(form.errors[field])}
    </span>
  ) : null;
};
